document.addEventListener("DOMContentLoaded", function () {
    let hTime = setInterval(() => {
        const load_more_button = document.querySelector(".ti-load-more-reviews-button");
        if (load_more_button) {
            load_more_button.innerHTML = "Show More";
            clearInterval(hTime);
        }
    }, 1000);

    document.querySelectorAll('.variant-label_custom').forEach(element => {
        element.addEventListener('click', function () {
            const variantSpecification = this.dataset.variantSpecification;
            if (document.querySelector('.accordion-item.accor_specifications .custom-accordion_content')) {
                document.querySelector('.accordion-item.accor_specifications .custom-accordion_content').innerHTML = `<p>${variantSpecification}</p>`;
            }
            
            // Make sure we don't interfere with the default variant selection
            setTimeout(() => {
                // Trigger change event on the associated radio input to ensure variant selection works
                const radioInput = document.getElementById(this.getAttribute('for'));
                if (radioInput && !radioInput.checked) {
                    radioInput.checked = true;
                    radioInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }, 0);
        })
    })


    let nCount = 0;
    let hPopupTime = setInterval(() => {
        const popupSignInButton = document.querySelector('[data-testid=POPUP] [data-testid=form-component] button');
        if(nCount > 6000) {
            clearInterval(hPopupTime);
        }
        if(popupSignInButton) {
            clearInterval(hPopupTime);
            popupSignInButton.classList.add('fourth-style');
            let text = popupSignInButton.innerHTML;
            const words = text.toLowerCase().split(' ');
            text = '';
            for (const [index, word] of words.entries()) {
                const ch = word.charAt(0);
                ch = ch.toUpperCase();
                if(index !== words.length - 1) {
                    text += `${ch}${word.substring(1)} `;
                } else {
                    text += `${ch}${word.substring(1)}`;
                }
            }
            popupSignInButton.innerHTML = text;
        }
        nCount ++;
    }, 100);


    const BisButton = document.querySelector('.klaviyo-bis-trigger');
    BisButton?.addEventListener('click', (e) => {
        e.preventDefault();
        let hBisTime = setInterval(() => {
            const BISIframe = document.getElementById('klaviyo-bis-iframe');
            if (BISIframe) {
                clearInterval(hBisTime);
                const BISDom = BISIframe.contentDocument || BISIframe.contentWindow.document;
                if (BISDom) {
                    const BISStyle = BISDom.createElement('style');
                    const BISFont = BISDom.createElement('link');
                    BISFont.setAttribute('href', 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
                    BISFont.setAttribute('rel', 'stylesheet');
                    BISStyle.innerHTML = `
                    #klaviyo-bis-modal {
                        font-family: Poppins, sans-serif;
                    }
                    .notify-me {
                        background-color:rgb(0, 90, 249);
                        border-radius: 100px;
                        border: none;
                    }
                    .notify-me:hover {
                        background-color: #2ccb93;
                    }
                `; 
                    BISDom.head.appendChild(BISFont);
                    BISDom.head.appendChild(BISStyle);
                    BISDom.querySelector('.control-group button')?.classList.add('notify-me');
                    // const BISModal = BISDom.getElementById('klaviyo-bis-modal');
                }
            }
        }, 100);
    });
});


//Webringly's Code

// Handle sticky header scroll behavior
document.addEventListener("DOMContentLoaded", ()=> { 
    const handleStickyHeader = () => {
        const thecoldpodStickyHeader = document.querySelector('sticky-header');
        if (!thecoldpodStickyHeader) return;
        
        if (window.scrollY === 0) {
            thecoldpodStickyHeader.style.top = '48px';
        } else {
            thecoldpodStickyHeader.style.top = '0';
        }
    };

    // Initial call to set correct position
    handleStickyHeader();
    
    // Add scroll event listener
    window.addEventListener('scroll', handleStickyHeader);
})

//END